import React from 'react';
import styled from 'styled-components';

import { Box } from '@rover/kibble/core';
import type { SelectOption } from '@rover/types/src/SelectOption';

export const Wrapper = styled(Box)`
  cursor: pointer;
  display: flex !important;
  min-height: 54px;
  padding: ${({ theme }) => `${theme.space['2x']} ${theme.space['4x']}`} !important;
`;
export const IconWrapper = styled(Box)`
  display: flex;

  svg {
    align-self: center;
    /* NOTE(Ryan) this icon just doesn't look centered visually without this 1px adjustment */
    bottom: 1px;
    fill: ${({ theme }) => theme.colors.brand.active_brand};
    flex: 0 0 22px;
    height: 22px;
    margin-right: ${({ theme }) => theme.space['4x']};
    position: relative;
    width: 22px;
  }
`;
const LabelWrapper = styled(Box)`
  color: ${({ theme }) => theme.colors.text.secondary};
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
`;
export const Title = styled(Box)`
  font-size: ${({ theme }) => theme.text['200'].fontSize};
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
  height: 22px;
`;
export const SubTitle = styled(Box)`
  font-size: ${({ theme }) => theme.text['100'].fontSize};
  height: 16px;
`;
export type Props = {
  data: SelectOption;
};

const IconOption = ({ data: { title, subtitle, icon: OptionIcon } }: Props): JSX.Element => {
  return (
    <Wrapper>
      {OptionIcon && (
        <IconWrapper>
          <OptionIcon />
        </IconWrapper>
      )}
      <LabelWrapper>
        <Title>{title as string}</Title>
        {subtitle && <SubTitle>{subtitle as string}</SubTitle>}
      </LabelWrapper>
    </Wrapper>
  );
};

export default IconOption;
